/* Project Import will be here */
import * as actions from '../actions/projectAndTask.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    projectAndTaskData: {
        savedProject: '',
        savedTask: ''
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.SAVE_PROJECT_AND_TASK:
            return {
                ...state,
                projectAndTaskData: {
                    ...state.projectAndTaskData,
                    savedProject: action.project,
                    savedTask: action.task
                }
            };            
        default:
            return state;
    }
}